<!-- Data Table -->
<div class="row">
    <div class="col-xxxl-12">
        <mat-card
            class="daxa-card top-selling-products-card mb-25 border-radius bg-white border-none d-block"
            [class.rtl-enabled]="themeService.isRTLEnabled()">
            <mat-card-header>
                <mat-card-title>
                    <div class="flex-row-div">
                        <form class="search-box position-relative">
                            <i class="material-symbols-outlined">
                                search
                            </i>
                            <input type="text" class="input-search d-block w-100 border-none outline-0"
                                placeholder="Search user..." (keyup)="applyFilter($event)" #input>
                        </form>
                        <button type="button" mat-button class="card-header-menu-btn" [matMenuTriggerFor]="cardHeaderMenu">
                            Ordina per: {{sortby}}
                        </button>
                        <mat-menu #cardHeaderMenu="matMenu" class="card-header-menu" xPosition="before">
                            @for (item of sortEnumList; track $index) {
                                <button mat-menu-item (click)="sortBy(item)">
                                    {{item}}
                                </button>
                            }
                        </mat-menu>
                    </div>
                </mat-card-title>
                <mat-card-subtitle>

                </mat-card-subtitle>
                <mat-card-subtitle>
                    <a mat-raised-button class="daxa" routerLink="/lockers/new-locker">
                        Nuovo Locker
                    </a>
                </mat-card-subtitle>
            </mat-card-header>
            <mat-card-content>
                <div class="recent-orders-table">
                    <div class="table-responsive">
                        <table mat-table [dataSource]="dataSource">

                          <!-- ID Column -->
                          <ng-container matColumnDef="IDLockerRacc">
                            <th mat-header-cell *matHeaderCellDef>
                              ID
                            </th>
                            <td mat-cell *matCellDef="let element">
                              {{ element.IDLockerRacc }}
                            </td>
                          </ng-container>

                          <!-- Tipologia Column -->
                            <ng-container matColumnDef="tenantType">
                                <th mat-header-cell *matHeaderCellDef>
                                    Tipologia
                                </th>
                                <td mat-cell *matCellDef="let element">
                                    {{ element.tenantType }}
                                </td>
                            </ng-container>

                            <!-- Address Column -->
                            <ng-container matColumnDef="address">
                                <th mat-header-cell *matHeaderCellDef>
                                    Indirizzo
                                </th>
                                <td mat-cell *matCellDef="let element">
                                    {{ element.address ?? '-'}}
                                </td>
                            </ng-container>

                            <!-- Address Column -->
                            <ng-container matColumnDef="city">
                                <th mat-header-cell *matHeaderCellDef>
                                    Città
                                </th>
                                <td mat-cell *matCellDef="let element">
                                    {{ element.city ?? '-'}}
                                </td>
                            </ng-container>

                            <!-- Province Column -->
                            <ng-container matColumnDef="province">
                                <th mat-header-cell *matHeaderCellDef>
                                    Provincia
                                </th>
                                <td mat-cell *matCellDef="let element">
                                    {{ element.province ?? '-' }}
                                </td>
                            </ng-container>

                            <!-- Cap Column -->
                            <ng-container matColumnDef="cap">
                                <th mat-header-cell *matHeaderCellDef>
                                  CAP
                                </th>
                                <td mat-cell *matCellDef="let element">
                                    {{ element.cap ?? '-' }}
                                </td>
                            </ng-container>

                            <!-- Status Column -->
                            <ng-container matColumnDef="status">
                                <th mat-header-cell *matHeaderCellDef>
                                    Stato
                                </th>
                                <td mat-cell *matCellDef="let element">
                                    <span class="daxa-badge pending d-inline-block">
                                    {{ element.lockerStatus }}
                                </span>
                                </td>
                            </ng-container>

                            <!-- Actions Column -->
                            <ng-container matColumnDef="actions">
                                <th mat-header-cell *matHeaderCellDef>

                                </th>
                                <td mat-cell *matCellDef="let element">
                                    <div class="action-info">
                                        <button type="button" mat-button matTooltip="View Project"
                                                matTooltipPosition="above"
                                                [routerLink]="['/lockers/details', element.IDLockerRacc]">
                                            <i class="material-symbols-outlined">
                                                edit
                                            </i>
                                        </button>

                                        <button type="button" mat-button matTooltip="Delete" matTooltipPosition="above"
                                                (click)="openDeleteDialog(element.IDLockerRacc)">
                                            <i class="material-symbols-outlined text-danger">
                                                delete
                                            </i>
                                        </button>
                                    </div>
                                </td>
                            </ng-container>

                            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

                            <!-- Row shown when there is no matching data. -->
                            <tr class="mat-row" *matNoDataRow>
                                <td class="mat-cell" colspan="4">Nessun dato trovato per il filtro: "{{ input.value }}
                                    "
                                </td>
                            </tr>
                        </table>
                    </div>
                    <mat-paginator class="mt-20" [pageSizeOptions]="[5, 10, 50]" showFirstLastButtons></mat-paginator>
                </div>
            </mat-card-content>
        </mat-card>
    </div>
</div>
